import React, { useState, useRef, useEffect } from 'react';
import { useEditMode } from '../context/EditContext';

function EditableText({ section, page, defaultValue, className, style, as: Tag = 'span', dangerouslySetInnerHTML }) {
  const { editMode } = useEditMode();
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(defaultValue);
  const [saving, setSaving] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const handleSave = async () => {
    if (!value.trim()) return;
    setSaving(true);
    try {
      await fetch('/api/admin/content', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ page, section, content: value })
      });
    } catch (e) {
      console.error('Save failed:', e);
    }
    setSaving(false);
    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSave();
    }
    if (e.key === 'Escape') {
      setValue(defaultValue);
      setIsEditing(false);
    }
  };

  if (!editMode) {
    if (dangerouslySetInnerHTML) {
      return <Tag className={className} style={style} dangerouslySetInnerHTML={{ __html: value }} />;
    }
    return <Tag className={className} style={style}>{value}</Tag>;
  }

  if (isEditing) {
    return (
      <textarea
        ref={inputRef}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={handleSave}
        onKeyDown={handleKeyDown}
        className={className}
        style={{
          ...style,
          background: '#1a1a2e',
          color: '#fff',
          border: '2px solid #4a0080',
          borderRadius: '4px',
          padding: '8px',
          minHeight: '60px',
          width: '100%',
          resize: 'vertical'
        }}
        disabled={saving}
      />
    );
  }

  return (
    <Tag
      className={className}
      style={{
        ...style,
        cursor: 'pointer',
        position: 'relative'
      }}
      onClick={() => setIsEditing(true)}
      onMouseEnter={(e) => {
        if (!editMode) return;
        e.target.style.outline = '2px dashed #4a0080';
        e.target.style.outlineOffset = '4px';
      }}
      onMouseLeave={(e) => {
        e.target.style.outline = 'none';
      }}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML ? { __html: value } : undefined}
    >
      {!dangerouslySetInnerHTML && value}
      {editMode && !isEditing && (
        <span style={{
          position: 'absolute',
          top: '-20px',
          right: '0',
          fontSize: '10px',
          background: '#4a0080',
          color: '#fff',
          padding: '2px 6px',
          borderRadius: '3px',
          opacity: 0.8
        }}>
          Click to edit
        </span>
      )}
    </Tag>
  );
}

export default EditableText;
